import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicApply from "./pages/PublicApply";
import CareerPage from "./pages/CareerPage";
import CareerApplyPage from "./pages/CareerApplyPage";
import JDWithL0 from "./pages/JDWithL0";
import ShortlistThanksPage from "./pages/ShortlistThanksPage";
import ShortlistDetailsForm from "./pages/ShortlistDetailsForm";
import CandidateApplyPage from "./pages/CandidateApply";
import WelcomePage from "./pages/WelcomePage";


function App() {
  return (
    <BrowserRouter basename="/careers">
      <Routes>
        <Route path="/" element={<CareerPage />} />
        <Route path="/apply/:jdId" element={<CareerApplyPage />} />
        <Route path="/job/l0/:token" element={<JDWithL0 />} />
        <Route path="/shortlist-confirm/:token" element={<ShortlistThanksPage />} />
        <Route path="/shortlist-details/:token" element={<ShortlistDetailsForm />} />
        <Route path="/apply/:jdId" element={<PublicApply />} />
        <Route path="/candidate/apply/:token" element={<CandidateApplyPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="*" element={<h2>Invalid Job Link</h2>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;